const stripTrailingSlash = url => url.replace(/\/$/, '')

export const append = path => location => ({
  ...location,
  pathname: location.pathname.replace(/\/?$/, '/' + path),
  query: {}
})

export const up = (amount=1) => location => {
  const parts = stripTrailingSlash(location.pathname).split('/').slice(0, -amount)
  return {
    ...location,
    pathname: parts.join('/')
  }
}



// WEBPACK FOOTER //
// client/utils/url.js